export default "__VITE_ASSET__BqbOBpks__"